<template>
    <div class="position-relative">
        <template
            v-if="hasContractConfigOptions"
        >
            <div class="mb-2">
                <h2 class="h4 mb-0">
                    {{ __('customers.contracts.technical_contract_settings') }}
                </h2>
                <small class="text-muted">{{ __(`customers.contracts.sorting.${sortingType}`) }}</small>
            </div>
            <ConfigOption
                v-for="(option, index) in contractConfigOptions"
                :key="index"
                :contract="contract"
                :error="getErrorMessage(option)"
                :hint="option.description"
                :is-valid="isFormFieldValid(`config_values.${option.name}.value`)"
                :option="option"
                :fulfillment-module="fulfillmentModuleValue"
                @update="updateValue(option, $event)"
            />
        </template>
        <template
            v-if="hasProductConfigOptions"
        >
            <div class="mb-2">
                <h2 class="h4 mb-0">
                    {{ __('customers.contracts.technical_product_settings') }}
                </h2>
                <small class="text-muted">{{ __(`customers.contracts.sorting.${sortingType}`) }}</small>
            </div>
            <ConfigOption
                v-for="(option, index) in productConfigOptions"
                :key="index"
                :contract="contract"
                :error="getErrorMessage(option)"
                :hint="option.description"
                :is-valid="isFormFieldValid(`config_values.${option.name}.value`)"
                :option="option"
                :fulfillment-module="fulfillmentModuleValue"
                @update="updateValue(option, $event)"
            />
        </template>
    </div>
</template>

<script>
import ConfigOption from '~@/Components/Customers/Contracts/FormFields/ConfigOption'

export default {
    name: 'ConfigOptions',
    components: {
        ConfigOption
    },
    props: {
        configValues: {
            type: Object,
            default: () => {
                return {}
            }
        },
        contract: {
            type: Object,
            default: () => {
                return {}
            }
        },
        form: {
            type: Object,
            default: () => {
                return {}
            }
        },
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isPreLiveContract: {
            type: Boolean,
            default: false
        },
        fulfillmentModule: {
            type: String,
            default: null
        },
        sortingType: {
            type: String,
            default: null
        }
    },
    emits: ['update:configValues'],
    computed: {
        configOptionsToDisplay: {
            get () {
                // Show config options (without instance settings) if existing contract is enabled, or it's a live contract
                if (this.form.existing_contract === true || this.isPreLiveContract === false) {
                    const configOptions = {}

                    for (const option of Object.values(this.form.config_values)) {
                        if (option.is_instance_setting === false) {
                            configOptions[option.name] = option
                        }
                    }

                    return configOptions
                }

                return this.form.config_values
            },
            set (value) {
                this.$emit('update:configValues', value)
            }
        },
        contractConfigOptions () {
            const options = {}
            for (const [name, value] of Object.entries(this.configOptionsToDisplay)) {
                if (value.is_product_setting) {
                    continue
                }
                options[name] = value
            }

            return options
        },
        productConfigOptions () {
            const options = {}
            for (const [name, value] of Object.entries(this.configOptionsToDisplay)) {
                if (value.is_product_setting === false) {
                    continue
                }
                options[name] = value
            }

            return options
        },
        fulfillmentModuleValue () {
            return this.fulfillmentModule !== null ? this.fulfillmentModule : this.contract?.fulfillment_module
        },
        hasContractConfigOptions () {
            return Object.keys(this.contractConfigOptions).length !== 0
        },
        hasProductConfigOptions () {
            return Object.keys(this.productConfigOptions).length !== 0
        }
    },
    methods: {
        getErrorMessage (row) {
            if (!this.errors[`config_values.${row.name}.value`]) {
                return this.errors[`config_values.${row.name}.value`]
            }

            return this.errors[`config_values.${row.name}.value`]
                .replaceAll('config_values.', '')
                .replaceAll('config values.', '')
                .replaceAll('.value', '')
        },
        setListValue (key, value, options) {
            this.configOptionsToDisplay[key].value = value
            this.configOptionsToDisplay[key].display_value = options.find((item) => item.value === value).label
        },
        setMultiselectValue (key, values, options) {
            this.configOptionsToDisplay[key].value = values.join(',')
            if (key === 'industry') {
                this.configOptionsToDisplay[key].display_value = values.join(',') + ' - ' + options.map((item) => values.includes(String(item.value)) ? item.text : null)
                    .filter((item) => item !== null)
                    .join(',')
            } else {
                this.configOptionsToDisplay[key].display_value = options.map((item) => values.includes(String(item.value)) ? item.text : null)
                    .filter((item) => item !== null)
                    .join(',')
            }
        },
        setModalValue (key, value) {
            if (typeof value === 'object') {
                this.configOptionsToDisplay[key].value = value.value
                this.configOptionsToDisplay[key].display_value = value.display_value
            } else {
                this.configOptionsToDisplay[key].value = value
            }
        },
        getDisplayValue (item) {
            return item.display_value === null ? item.value : item.display_value
        },
        updateValue (option, value) {
            if (['array', 'bool', 'email', 'integer', 'numeric', 'string', 'text'].includes(option.type)) {
                this.configOptionsToDisplay[option.name].value = value
            } else if (option.type === 'list') {
                this.setListValue(option.name, value, option.options)
            } else if (option.type === 'multiselect' || option.type === 'search_list') {
                this.setMultiselectValue(option.name, value, option.options)
            } else if (option.type === 'modal') {
                this.setModalValue(option.name, value, option.options)
            }
        }
    }
}
</script>
